module.exports = __webpack_public_path__ + "img/m.6742026d.jpg";